export const CONTAINER_EL_ID = 'docs-tree-container';
